import { render, staticRenderFns } from "./TimeGuru.vue?vue&type=template&id=4b6fbca2&scoped=true"
import script from "./TimeGuru.vue?vue&type=script&lang=js"
export * from "./TimeGuru.vue?vue&type=script&lang=js"
import style0 from "./TimeGuru.vue?vue&type=style&index=0&id=4b6fbca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6fbca2",
  null
  
)

export default component.exports